import { FormBase } from "../../util/form-base-form";

class BackNumberToggleFormBase extends FormBase {
    public override getInput(
        root: ParentNode | Event | EventTarget | Element | null | undefined,
        selector?: string,
    ): HTMLInputElement | null {
        return super.getInput(root, selector);
    }

    public getDateContainer(root: ParentNode | Event | EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(root, '[data-back-number-date-container="1"]', HTMLElement);
    }
}

const formBase = new BackNumberToggleFormBase();

class BackNumberToggleForm {
    public static getToggle(root: HTMLElement | Document): HTMLInputElement | null {
        return formBase.getInput(root, 'input[type="checkbox"][data-back-number-toggle="1"]');
    }

    public static getDateInput(root: HTMLElement | Document): HTMLInputElement | null {
        return formBase.getInput(root, 'input[type="date"][data-back-number-date="1"]');
    }

    public static getDateContainer(
        root: HTMLElement | Document,
        dateInput: HTMLInputElement | null,
    ): HTMLElement | null {
        return formBase.getDateContainer(root) || formBase.getDateContainer(dateInput);
    }
}

export { BackNumberToggleForm };
